import _regeneratorRuntime from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/createClass";
import _defineProperty from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";

var DineInOrder = /*#__PURE__*/function () {
  function DineInOrder(config, axios) {
    _classCallCheck(this, DineInOrder);

    _defineProperty(this, "axios", void 0);

    _defineProperty(this, "config", void 0);

    this.axios = axios;
    this.config = config;
  }

  _createClass(DineInOrder, [{
    key: "initiateDineInOrder",
    value: function () {
      var _initiateDineInOrder = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(restaurantId, id, source, kind, clearCart) {
        var response;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.axios.get(this.config.postfix.INIT_DINE_IN_ORDER, {
                  params: {
                    restaurantId: restaurantId,
                    id: id,
                    source: source,
                    kind: kind,
                    clearCart: clearCart
                  }
                });

              case 2:
                response = _context.sent;

                if (!(response.status === 200)) {
                  _context.next = 5;
                  break;
                }

                return _context.abrupt("return", {
                  status: "success"
                });

              case 5:
                return _context.abrupt("return", {
                  status: "error",
                  errorResponse: response.data.errorResponse
                });

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function initiateDineInOrder(_x, _x2, _x3, _x4, _x5) {
        return _initiateDineInOrder.apply(this, arguments);
      }

      return initiateDineInOrder;
    }()
  }]);

  return DineInOrder;
}();

export { DineInOrder as default };